
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/consultants",
      function () {
        return require("private-next-pages/consultants/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/consultants"])
      });
    }
  